module.exports = new __parcel__URL__("gosat-based-ch4budget-yeargrid-v1.thumbnails.priori.total.00e4c59a.png").toString();